import request from "@/util/request";


/**
 * 获取收支记录标签选项
 * @returns {*}
 */
export function getTagOptions() {
    return request({
        url: '/payment/get_tag_options',
        method: 'get'
    })
}

/**
 * 获取收支记录明细
 * @returns {*}
 */
export function getPaymentRecords(params) {
    return request({
        url: '/payment/get_payment_records',
        method: 'get',
        params: params
    })
}

/**
 * 获取收支记录统计
 * @returns {*}
 */
export function getPaymentReports(params) {
    return request({
        url: '/payment/get_payment_reports',
        method: 'get',
        params: params
    })
}

/**
 * 获取标签收支明细
 * @returns {*}
 */
export function getPaymentReportsTagInfo(params) {
    return request({
        url: '/payment/get_payment_reports_tag_info',
        method: 'get',
        params: params
    })
}
